// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Potential fixes for an undesirable and intermittent flashing background bug. */
.glide__slide {
  /* Fix for flashing background image on slide */
  transform: translate3d(0, 0, 0);
}

.slider__frame[class*=active] {
  z-index: 1;
}

._10XKC {
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 0;
  outline: 0;
  padding: 12px;
  background-color: #EEE;
  position: absolute;
  border-radius: 50px;
  top: 35%;
}

._10XKC:hover {
  background-color: #DEDEDE;
  transition: background-color .2s ease-in-out;
}

.Glide-rightArrow {
  right: 1.5rem;
  padding-left: 14px;
}

.Glide-leftArrow {
  left: 1.5rem;
  padding-right: 14px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-glidejs/dist/index.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;EACE,+CAA+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Potential fixes for an undesirable and intermittent flashing background bug. */\n.glide__slide {\n  /* Fix for flashing background image on slide */\n  transform: translate3d(0, 0, 0);\n}\n\n.slider__frame[class*=active] {\n  z-index: 1;\n}\n\n._10XKC {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border: 0;\n  outline: 0;\n  padding: 12px;\n  background-color: #EEE;\n  position: absolute;\n  border-radius: 50px;\n  top: 35%;\n}\n\n._10XKC:hover {\n  background-color: #DEDEDE;\n  transition: background-color .2s ease-in-out;\n}\n\n.Glide-rightArrow {\n  right: 1.5rem;\n  padding-left: 14px;\n}\n\n.Glide-leftArrow {\n  left: 1.5rem;\n  padding-right: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
